import React, { ReactNode, useCallback, useEffect, useRef } from "react";
import styled from "styled-components";
import { useSpring, animated } from "react-spring";
import { ReactComponent as CloseIcon } from "assets/close.svg";

interface IModal {
  isOpen: boolean;
  setOpen: Function;
  children: ReactNode;
}

const Modal = ({ isOpen, setOpen, children }: IModal) => {
  const modalRef = useRef(null);

  const animation = useSpring({
    config: {
      duration: 250,
    },
    opacity: isOpen ? 1 : 0,
  });

  const closeModal = (e: any) => {
    if (modalRef.current === e.target) {
      setOpen(false);
    }
  };

  const keyPress = useCallback(
    (e) => {
      if (e.key === "Escape" && isOpen) {
        setOpen(false);
      }
    },
    [isOpen, setOpen]
  );

  useEffect(() => {
    document.addEventListener("keydown", keyPress);
    return () => document.removeEventListener("keydown", keyPress);
  }, [keyPress]);

  return (
    <>
      {isOpen && (
        <Background onClick={closeModal} ref={modalRef}>
          <animated.div style={animation}>
            <ModalWrapper>
              <CloseModalButton onClick={() => setOpen(false)} />
              {children}
            </ModalWrapper>
          </animated.div>
        </Background>
      )}
    </>
  );
};

export default Modal;

const Background = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(58, 58, 58, 0.6);
  position: fixed;
  top: 0;
  left: 0;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalWrapper = styled.div`
  background-color: ${(p) => p.theme.primary};
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
  position: fixed;
  padding: 1rem;
  border-radius: 0.5rem;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.2);
`;

const CloseModalButton = styled(CloseIcon)`
  cursor: pointer;
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  width: 16px;
  height: 16px;
  padding: 0;
  z-index: 10;

  &:hover {
    opacity: 0.7;
  }
`;
